export default __webpack_public_path__ + "static/media/menu.a8287c67.png";